module.exports = __webpack_public_path__ + "img/44.be3531fe.png";